import React from 'react';
import { statusStyle } from '../../utils/reportFormat';
import * as fmt from '../../lib/format';

interface Props {
  timeline: { status: string; at: string }[];
  statusNow: string;
  statusAtEnd: string | null;
  isCurrent: boolean;
}

// The epic's own status history, oldest first, in the same dot-and-pill style as the report.
export default function Journey({ timeline, statusNow, statusAtEnd, isCurrent }: Props) {
  if (timeline.length === 0) {
    return <p className="px-4 py-8 text-center text-sm text-gray-500">No status changes recorded for this epic.</p>;
  }
  const moved = !isCurrent && statusAtEnd !== null && statusAtEnd !== statusNow;
  return (
    <div className="px-4 py-4">
      <ol className="relative space-y-3.5">
        {timeline.map((t, i) => {
          const c = statusStyle(t.status);
          const last = i === timeline.length - 1;
          return (
            <li key={`${t.at}-${i}`} className="relative flex items-start gap-3 pl-0.5">
              {!last && <span className="absolute left-[6px] top-3.5 h-[calc(100%+0.5rem)] w-px bg-gray-200" aria-hidden />}
              <span className={`relative z-10 mt-1 h-3 w-3 shrink-0 rounded-full ring-2 ring-white ${c.dot}`} aria-hidden />
              <div className="flex flex-wrap items-center gap-x-2.5 gap-y-0.5">
                <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${c.badge}`}>
                  {t.status}
                </span>
                <span className="whitespace-nowrap text-[0.6875rem] tabular-nums text-gray-500">{fmt.date(t.at)}</span>
              </div>
            </li>
          );
        })}
      </ol>
      {moved && <p className="mt-4 text-xs text-gray-500">Since then the epic has moved on. Today it is {statusNow}.</p>}
    </div>
  );
}
